import React, { useRef, useState, useEffect } from 'react';
import styles from './Button.module.scss';
import PropTypes from 'prop-types';

import * as Tone from 'tone';
import hovering from '../../assets/audio/hover.mp3';
import select from '../../assets/audio/click.mp3';

const Button = ({ icon, disabled, children, mute, ...props }) => {
  const [hover, setHover] = useState(false);

  const buttonRef = useRef(null);
  const hoverAudio = useRef(null);
  const clickAudio = useRef(null);

  useEffect(() => {
    const button = buttonRef.current;
    hoverAudio.current = new Tone.Player(hovering).toDestination();
    clickAudio.current = new Tone.Player(select).toDestination();

    const hoverStart = () => {
      setHover(true);
    };
    const hoverEnd = () => {
      setHover(false);
    };
    const click = () => {
      if (!disabled && !mute) {
        playAudio(clickAudio.current);
      }
    };

    button.addEventListener('pointerenter', hoverStart);
    button.addEventListener('pointerleave', hoverEnd);
    button.addEventListener('pointerdown', click);

    return () => {
      button.removeEventListener('pointerenter', hoverStart);
      button.removeEventListener('pointerleave', hoverEnd);
      button.removeEventListener('pointerdown', click);
    };
  }, [disabled, mute]);

  useEffect(() => {
    if (hover && !disabled && !mute) {
      playAudio(hoverAudio.current);
    }
  }, [hover, disabled, mute]);

  const playAudio = (audio) => {
    if (audio) {
      Tone.loaded().then(() => {
        audio.start();
      });
    }
  };

  return (
    <button
      className={styles.button}
      disabled={disabled}
      {...props}
      ref={buttonRef}
    >
      {icon && <div className={styles.icon}>{icon()}</div>}
      {children}
    </button>
  );
};

Button.propTypes = {
  icon: PropTypes.func,
  disabled: PropTypes.bool,
  mute: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  icon: null,
  disabled: false,
  mute: false,
  children: null,
};

export default Button;
